import { spacing } from '@chegg-ui/theme'
import { useEffect, useState, useRef } from 'react'
import { generate } from 'short-uuid'

const getContainerCss = (isQuickActionPanelOpen: boolean) => `
  position: fixed;
  bottom: ${isQuickActionPanelOpen ? '5.6rem' : '3.8rem'};
  right: ${isQuickActionPanelOpen ? spacing.px24 : spacing.px48};
  z-index: 5000;
`

export const useToastPortal = (isQuickActionPanelOpen?: boolean) => {
  const [portalId] = useState(`toast-id-${generate()}`)
  const [loaded, setLoaded] = useState(false)
  const divRef = useRef(null)

  useEffect(() => {
    const div = document.createElement('div')
    div.id = portalId
    div.style.cssText = getContainerCss(isQuickActionPanelOpen)
    document.body.append(div)
    divRef.current = div
    setLoaded(true)

    return () => {
      document.getElementById(portalId)?.remove()
    }
  }, [portalId])

  // useEffect to update the styles based on isQuickActionPanelOpen
  useEffect(() => {
    if (divRef.current) {
      divRef.current.style.cssText = getContainerCss(isQuickActionPanelOpen)
    }
  }, [isQuickActionPanelOpen])

  return { loaded, portalId }
}
